import { render, staticRenderFns } from "./switchItems.vue?vue&type=template&id=89adce38&scoped=true&"
import script from "./switchItems.vue?vue&type=script&lang=js&"
export * from "./switchItems.vue?vue&type=script&lang=js&"
import style0 from "./switchItems.vue?vue&type=style&index=0&id=89adce38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89adce38",
  null
  
)

export default component.exports